export const SEND_API =  "https://fazoacademy.com/php/sendmail.php";